import { BsShieldLockFill } from 'react-icons/bs';

import Button from '@/tayara-kit/Button';
import Input from '@/tayara-kit/Input';
import Text from '@/tayara-kit/Text';

const SecurityTab = ({
  password,
  repassword,
  oldPassword,
  onSubmit,
  updatePasswordTab,
}: any) => (
  <div className="min-h-[400px]">
    <div>
      <Text
        as="h2"
        text="Sécurité"
        className="text-2xl text-gray-600 font-bold md:mb-2"
      />
      <Text
        as="h3"
        text="Modifier mon mot de passe"
        className="text-lg font-light text-gray-600 "
      />
      {/* Username and phone number */}
      <div className="flex flex-col md:flex-row flex-wrap flex-1  gap-4">
        <div className="basis-[51%] mb-4">
          <Text
            as="label"
            text="Ancien mot de passe (Obligatoire)"
            className="text-xs font-bold text-gray-600"
          />
          <Input
            type="password"
            startIcon={BsShieldLockFill}
            value={oldPassword}
            onChange={(e) => updatePasswordTab('oldPassword', e.target.value)}
          />
        </div>
        <div className="basis-[51%]">
          <Text
            as="label"
            text="Nouveau mot de passe (Obligatoire)"
            className="text-xs font-bold text-gray-600"
          />
          <Input
            value={password}
            onChange={(e) => updatePasswordTab('password', e.target.value)}
            type="password"
            startIcon={BsShieldLockFill}
          />
        </div>

        <div className="basis-[51%]">
          <Text
            as="label"
            text="Confirmer nouveau mot de passe (Obligatoire)"
            className="text-xs font-bold text-gray-600"
          />
          <Input
            type="password"
            value={repassword}
            onChange={(e) => updatePasswordTab('repassword', e.target.value)}
            startIcon={BsShieldLockFill}
          />
        </div>
      </div>
      <div className="mt-8 flex">
        <Button
          aria-label="Mettre à jour mon mot de passe"
          onClick={onSubmit}
          className="btn-primary"
        >
          Mettre à jour mon mot de passe
        </Button>
      </div>
    </div>
  </div>
);

export default SecurityTab;
